import styled from "styled-components"

export const FilterWrapper = styled.div`
display: flex;
        justify-content: space-between;
        align-items: center;
     
        .filter_item{
            display: flex;
            align-items: center;
        }
       .btn-filter{
        width: 80px;
       }
       .limit_price{
            min-width: 250px;
            display: flex;
            align-items: center;
            label{
                white-space: nowrap;
            }
       }
       .input_person{
        height: 40px;
        width: 60px;
       }
       .button_control{
        display: flex;
        align-items: flex-end;
       }
       .province,.price{
        select{
            height: 40px;
            background-color: #fff;
            border: 1px solid #d9d9d9;
            min-width: 120px;
            outline: none;
        }
       }
`
